import "react-app-polyfill/ie11"; // For IE 11 support
import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import { ApolloProvider } from "@apollo/client";
import { IntercomProvider } from "react-use-intercom";
import { AuthProvider } from "./lib/auth";

import "bootstrap/dist/css/bootstrap.css";
import "./index.css";
import App from "./App";
import apolloClient from "./apolloClient";
import * as serviceWorker from "./serviceWorker";

import { BlockAppAccess, BLOCK_APP_ACCESS } from "./BlockAppAccess";

const AppWrapper = () => (
  <ApolloProvider client={apolloClient}>
    <Router basename={process.env.PUBLIC_URL}>
      <AuthProvider>
        <IntercomProvider
          appId={process.env.REACT_APP_INTERCOM_APP_ID}
          autoBoot={false}
        >
          <App />
        </IntercomProvider>
      </AuthProvider>
    </Router>
  </ApolloProvider>
);

const RenderView = () =>
  BLOCK_APP_ACCESS ? <BlockAppAccess /> : <AppWrapper />;

const container = document.getElementById("root");
const root = createRoot(container);
root.render(<RenderView />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
